import { Pipe, PipeTransform } from '@angular/core';
import { getUserUtcOffset } from 'src/app/shared/utils/helpers';

@Pipe({
  name: 'adaptToUserUtcOffset',
})
export class AdaptToUserUtcOffsetPipe implements PipeTransform {

  transform(value: any): Date | string {
    if (!value) return '';
    const shifted = new Date(value);
    // Minutes, not hours: half-hour zones give a fractional offset that setHours() drops.
    shifted.setMinutes(shifted.getMinutes() + Math.round((this.currentOffsetHours() ?? 0) * 60));
    return shifted;
  }

  /** Overridable seam — `getUserUtcOffset` is a const export ESM makes non-spyable. */
  protected currentOffsetHours(): number {
    return getUserUtcOffset();
  }
}
